<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm @submit="signin">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    placeholder="Username"
                    autocomplete="username email"
                     name="email"
                     v-model="email"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    name="password"
                    v-model="password"
                    autocomplete="curent-password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <div class="alert alert-danger" role="alert" v-if="showError">
                    Login fail!
                  </div>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" type="submit">Login</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0">Forgot password?</CButton>
                      <CButton color="link" class="d-lg-none">Register now!</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Dashboard</h2>
                <p>Build designs with PUF-based hardware security technology.</p>
                <!--<CButton
                  color="light"
                  variant="outline"
                  size="lg"
                  @click="register"
                >
                  Register Now!
                </CButton>
                -->
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'Login',
  data: function(){
    return {
      email: '',
      password: '',
      showError: false
    }
  },methods: {
    register: function(e){
      this.$router.push("/pages/register")
    },
    signin(e) {
      var self = this;
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
      .then(() => {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(function(p) {
          if(process.env.NODE_ENV === 'production' && !p.user.emailVerified){
            self.showError = true;
            throw new Error("Email is not verified!");
          }else{
            p.user.getIdToken(true).then(function(idToken) {
              self.$http.post('/v1/api/login', {
                  token: idToken
              })
              .then(function (response) {
                //self.$store.state.user = response.data;
                if(self.$route.query.redirect){
                  self.$router.push(self.$route.query.redirect)
                } else {
                  self.$router.push("/dashboard")
                }
              })
              .catch(function (error) {
                self.showError = true;
                //console.log(error);
              })
              .then(function () {
                // always executed
              });  
            }).catch(function(error) {
              // Handle error
              self.showError = true;
            });
          }
        }).catch(function(error) {
          //console.log(error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          self.showError = true;
          // ...
        });
      }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
      });
      e.preventDefault();
    }
  }
}
</script>
